function ds(sorgu) {
    const p = new URLSearchParams();
    p.set('baslangic', sorgu.baslangic);
    p.set('bitis', sorgu.bitis);
    if (sorgu.noktaId)
        p.set('noktaId', sorgu.noktaId);
    return `?${p.toString()}`;
}
export async function gelirRaporuGetir(istemci, sorgu) {
    return istemci.istek(`/raporlar/gelir${ds(sorgu)}`);
}
export async function analitikRaporuGetir(istemci, sorgu) {
    return istemci.istek(`/raporlar/analitik${ds(sorgu)}`);
}
//# sourceMappingURL=raporlar.js.map